import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface userRoleInfo {
    role_info: Array<any>;
    editAccess: boolean;
    viewAccess: boolean;
}

const initialState: userRoleInfo = {
  role_info: [],
  editAccess:false,
  viewAccess:false
};

const roleInfo = createSlice({
  name: 'role_info_slice',
  initialState,
  reducers: {
    setRoleInfo: (
      state: any,
      action: PayloadAction<userRoleInfo>,
    ) => {
      const payload = action.payload;
      state.role_info = payload;
    },
    setEditAccess: (
      state: any,
      action: PayloadAction<boolean>
    ) => {
      const payload = action.payload;
      state.editAccess = payload;
    },
    setViewAccess: (
      state: any,
      action: PayloadAction<boolean>
    ) => {
      const payload = action.payload;
      state.viewAccess = payload;
    },
    remove_userRole:(
      state: any
    ) => {
      state.role_info = "";
      state.editAccess = false
      state.viewAccess = false
    }
  },
});

export const { setRoleInfo, remove_userRole, setEditAccess, setViewAccess} = roleInfo.actions;

export default roleInfo.reducer;
